module.exports = __webpack_public_path__ + "img/toolbar_bg2.feacfab2.png";